import api from '../../../src/services/ApiServices';
import {SearchType} from "../../../src/services/types/ApiTypes";
import { removeTimeZone } from '../../../src/common/utils/datetime';
import { getCurrentUserGroupMember } from '../../../src/common/user/UserActions';

'use strict';

angular
    .module('dstreamApp.components')
    .controller('DsOutOfOfficeModalController', function($rootScope, $scope, $filter, $uibModalInstance, $ngRedux, webServices) {
        // if we are editing already set substitute
        $scope.editingSubstitute = $.isEmptyObject($scope.$parent.Substitute) ? false : true;
        $scope.replacementPlaceholder = $filter('translate')('views.home.dashboard.select_replacement');
        // create temporary substitute object
        // TODO: fix angular.copy for post-1.6.9
        $scope.editSubstitute = $scope.editingSubstitute ? angular.copy($scope.$parent.Substitute) : {};
        $scope.$parent.setSubstitutes = $scope.editingSubstitute ? $scope.editSubstitute.ToSubstituteName : '';

        // get dates either from already set object or set them as default
        $scope.fromOpen = true;
        $scope.toOpen = false;
        $scope.fromModel = $scope.editingSubstitute ? new Date($filter('date')($scope.editSubstitute.From, 'yyyy-MM-dd')) : new Date();
        $scope.toModel = $scope.editingSubstitute ? new Date($filter('date')($scope.editSubstitute.To, 'yyyy-MM-dd')) : '';
        $scope.fromOptions = {
            showWeeks: false,
            startingDay: 1,
            minDate: new Date(),
            maxDate: $scope.toModel
        };
        $scope.toOptions = {
            showWeeks: false,
            startingDay: 1,
            minDate: $scope.fromModel
        };

        /********** SCOPE FUNCTIONS **********/
        /*
            Open from datepicker
         */
        $scope.openFrom = function() {
            $scope.toOpen = false;
            $scope.fromOpen = true;
            $scope.fromOptions.maxDate = $scope.toModel;
        };

        $scope.focusInput = function ($event) {
            setTimeout(function() {
                angular.element($event.currentTarget).parent().find('input').triggerHandler('click');
            });
        };

        /*
            Open to datepicker
         */
        $scope.openTo = function() {
            $scope.fromOpen = false;
            $scope.toOpen = true;
            $scope.toOptions.minDate = $scope.fromModel;
        };

        $scope.$watch('fromModel', function(newValue, oldValue) {
            if(newValue && newValue != oldValue && !$scope.toModel) {
                $scope.openTo();
            }
        });

        $scope.$watch('toModel', function(newValue, oldValue) {
            if(newValue && newValue != oldValue && !$scope.fromModel) {
                $scope.openFrom();
            }
        });

        /**
         * getActiveGroupMembers
         * gets the list of active groupMembers
         */
        $scope.getActiveGroupMembers = function (namePart) {
            const searchParams = {
                SortItems: [],
                PagingOptions: {
                    Page: 1,
                    Count: 25,
                },
                Restrictions: [{
                    Field: 'IsActive',
                    Value: true,
                    Values: null,
                    FieldSearchType: SearchType.NotSelected,
                }, {
                    Field: 'GeneralSearch',
                    Value: namePart || '',
                    Values: null,
                    FieldSearchType: SearchType.NotSelected,
                }],
                SupplierId: 0,
            };
            return api.company.getGroupMembersMicro(searchParams).then((response) => {
                $scope.groupMembers = response.data.Items;
                return $scope.groupMembers.filter((gm) => gm.Name.toLowerCase().includes(namePart.toLowerCase()));
            });

        };

        /*
            Set substitute name and id on value change
         */
        $scope.updateSubstitute = function (item) {
            $scope.editSubstitute.ToSubstituteId = item.Id;
            $scope.editSubstitute.ToSubstituteName = item.Name;
        };

        /*
            Save/Update substitute
         */
        $scope.saveSubstitute = function () {
            if (validateModal()) {
                $scope.editSubstitute.From = removeTimeZone($scope.fromModel);
                $scope.editSubstitute.To = removeTimeZone($scope.toModel)

                webServices.addOrUpdateSubstitute($scope.editSubstitute).then(function (response) {
                    if (response.data != null) {
                        $scope.$parent.Substitute = response.data;
                        $scope.$parent.Substitute.ToSubstituteName = $scope.$parent.setSubstitutes;
                        $ngRedux.dispatch(getCurrentUserGroupMember(true));
                        $rootScope.$emit("app.performUpdateSubstitute");
                        $uibModalInstance.close();
                    }
                }, function (data) {
                    console.log(data);
                });
            }
        };

        /*
            Delete current substitute
         */
        $scope.deleteSubstitute = function () {
            if ($scope.$parent.Substitute && $scope.$parent.Substitute.ToSubstituteId) {
                webServices.deleteUserSubstitutes($scope.$parent.Substitute.GroupMemberId).then(function (response) {
                    $scope.$parent.setSubstitutes = "";
                    $scope.$parent.Substitute = {};
                    $scope.editingSubstitute = false;
                    $ngRedux.dispatch(getCurrentUserGroupMember(true));
                    $rootScope.$emit("app.performUpdateSubstitute");
                    $uibModalInstance.close();
                }, function (data) {
                    console.log(data);
                });
            }
        };

        /*
            Validate modal
         */
        function validateModal() {
            return !(!$scope.fromModel || !$scope.toModel || !$scope.$parent.setSubstitutes || $scope.$parent.setSubstitutes.length == 0 || $scope.$parent.setSubstitutes != $scope.editSubstitute.ToSubstituteName);
        }
    });